export default "<span class=\"text-white badge badge-pill px-3\" [ngClass]=\"getColor(rol)\">\n  {{getType(rol)}}\n</span>\n";